export default "__VITE_ASSET__Cj3yP_Nr__"